import React from "react";
import { Paper, Button, withStyles } from "@material-ui/core";
import styles from "./recommendationStyles";
import DetailsTable from "./DetailsTable";
import RouteOnCard from "./RouteOnCard";
import Tooltip from "../../../../common/StyledToolTip";
import { DRIVER_EVENTS,SHOW_DRIVER_EVENTS } from "../constants"
import { sortStopsBySequence, getCurrentDriverStatus } from "../../utils/utils";

const getDriverStatus = (data) => {
  const stopsWithoutDelays = sortStopsBySequence(data?.routeStops);
  if (
    data?.currentStatus &&
    [DRIVER_EVENTS.ArrivedAtStop, DRIVER_EVENTS.EnrouteToStop].includes(
      data.currentStatus.status
    )
  ) {
    return getCurrentDriverStatus({
      currentStatus: data.currentStatus,
      stops: stopsWithoutDelays,
    });
  }
  const nextStop = stopsWithoutDelays?.findIndex(
    (stop) => !stop.isStopCompleted
  );
  return nextStop > -1
    ? `${SHOW_DRIVER_EVENTS.NextEnrouteTo} ${stopsWithoutDelays[nextStop].name}`
    : "";
};

const Recommendation = ({ classes, data, onClick, terminalOffset }) => {
  const driverStatus = getDriverStatus(data);
  return (
    <Paper className={classes.recommendationContainer}>
      <div className={classes.recommendedDrivers}>
        <div className={classes.upperDetails}>
          <div className={classes.routeIcon}>
            <RouteOnCard color={data.color} />
          </div>
          <div className={classes.detailsContainer}>
            <div
              className={
                data.recommendationRank === 1
                  ? classes.driverNameContainerWithBestChoice
                  : classes.driverNameContainer
              }
            >
              <Tooltip title={`${data.driverName} (${data.driverNumber})`}>
                <span className={classes.driverName}>
                  {data.driverName} ({data.driverNumber})
                </span>
              </Tooltip>
            </div>
            {data.recommendationRank === 1 && (
              <span className={classes.bestChoice}>(Best Choice)</span>
            )}
            <div>
              <span className={classes.upperEnrouteToTitle}>
                {driverStatus}
              </span>
              <span className={classes.upperEnrouteToValue}> </span>
            </div>
          </div>

          <Button
            color="primary"
            variant="contained"
            size="small"
            className={classes.assignBtn}
            onClick={onClick}
          >
            Assign
          </Button>
        </div>
        <div className={classes.lowerDetails}>
          <DetailsTable data={data} terminalOffset={terminalOffset} />
        </div>
      </div>
    </Paper>
  );
};

export default withStyles(styles)(Recommendation);
